export const QUESTIONS_PROGRESS_PERCENT = 95;
export const EXECUTION_STEPS_PROGRESS_PERCENT = 100 - QUESTIONS_PROGRESS_PERCENT;
